import { render, staticRenderFns } from "./framework.vue?vue&type=template&id=6e049fe2&scoped=true"
import script from "./framework.vue?vue&type=script&lang=js"
export * from "./framework.vue?vue&type=script&lang=js"
import style0 from "./framework.vue?vue&type=style&index=0&id=6e049fe2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e049fe2",
  null
  
)

export default component.exports